import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { shoppingCart } from "../../../../services";
import { products } from "../../../../services";
import { IRootState } from "../../../../models/interface";
import { ICartState } from "../../../../models/interface/ICartState";
import { IProduct } from "../../../../models/productModel";
import { IShoppingCartItem } from "../../../../models/IShoppingCartModel";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import IPromotionVoucherCodeModel from "../../../../models/IPromotionVocherCodeModel";
import IReferralCodeModel from "../../../../models/IReferralCodeModel";
import {
  checkInventoryProductAddToCart,
  updateCaptchaToken,
  updateInvoiceInfo,
  updateOTPInfo,
  updatePaymentMethod,
} from "../../../../services/shoppingCart";
import { PROPERTY_TYPE } from "../../../../common/constant";
import i18n from "../../../../i18n";
import { notification } from "antd";
import IInvoiceInfoModel from "../../../../models/IInvoiceInfoModel";
import * as GTM from "../../../../components/tracking/GTM";
import { IOTPInfo } from "../../../../screens/Checkout/verifyOTPModal";
const {
  addCartItem,
  updateShoppingCartItems,
  updateVoucherCode,
  updateReferralCode,
} = shoppingCart;
const initialState: ICartState = {
  carts: shoppingCart.getShoppingCart(),
  dataEncrypt: "",
};

export const cartSlice = createSlice({
  name: "cart",
  initialState: initialState,
  reducers: {
    addToCart: (state, action) => {
      let sci: IShoppingCartItem = {
        quantity: 1,
        product: action.payload,
        _id: uuidv4(),
        product_property: action.payload?.product_property,
      };
      state.carts = addCartItem(sci);
      // state.carts.push(action.payload);
    },
    getShoppingCart: (state) => {
      const cart = shoppingCart.getShoppingCart();
      state.carts = _.clone(cart);
    },
  },
});

export const { addToCart, getShoppingCart } = cartSlice.actions;

export const addProductToCart =
  (product: IProduct, isQuickPurchase: boolean, quantity: number = 1) =>
  async (dispatch: Dispatch) => {
    if (isQuickPurchase) {
      const productInfo = await products.getProductInfoToCart(
        product._id,
        product.code,
        product.parent_pro_id || "",
        product.cat_id_v2 || ""
      );

      if (productInfo) {
        let productProperty = productInfo.product_property;
        let giftPromotions = productInfo?.product_gifts?.map((x) => {
          return {
            _id: uuidv4(),
            quantity: x.quantity,
            sealed_price: x.price,
            default_prop: x.default_prop,
            feature_id: x.feature_id,
            product: {
              code: x.code,
              name: x.name,
              img: x.img,
              _id: x.feature_id + "",
            },
            product_name_extra: x.note,
            options: x.options,
          };
        });

        if (product.product_property) {
          if (product.product_property[PROPERTY_TYPE.image]) {
            productProperty = {
              ...productInfo.product_property,
              [PROPERTY_TYPE.image]:
                product.product_property[PROPERTY_TYPE.image],
            };
          }

          if (product.product_property[PROPERTY_TYPE.foam]) {
            productProperty = {
              ...productInfo.product_property,
              [PROPERTY_TYPE.foam]:
                product.product_property[PROPERTY_TYPE.foam],
            };
          } else {
            //Nếu không có foam thì xoá giá trị foam mặc định
            delete productProperty[PROPERTY_TYPE.foam];
          }
        } else {
          //Nếu không có product property thì xoá giá trị foam mặc định
          delete productProperty[PROPERTY_TYPE.foam];
        }

        if (product.product_gifts && product.product_gifts.length) {
          giftPromotions = product.product_gifts.map((x: any) => {
            return {
              _id: uuidv4(),
              quantity: x.quantity,
              sealed_price: x.price,
              default_prop: x.default_prop,
              feature_id: x.feature_id,
              product: {
                code: x.code,
                name: x.name,
                img: x.img,
                _id: x.feature_id + "",
              },
              product_name_extra: x.note,
              options: x.options,
            };
          });
        }

        let sci: IShoppingCartItem = {
          quantity: quantity,
          product: product,
          _id: uuidv4(),
          product_property: productProperty,
          gift_promotions: giftPromotions,
        };

        const checkInventory = await checkInventoryProductAddToCart(sci);

        if (checkInventory.isValid) {
          if (checkInventory.messageCode == "product_out_of_stock") {
            notification.warning({
              message: i18n.t(checkInventory.messageCode),
              description: checkInventory.message,
            });
          } else {
            notification.error({
              message: i18n.t(checkInventory.messageCode),
            });
          }

          return checkInventory;
        }
        let unit_price = sci.product?.feature?.price_promotion
          ? parseInt(sci.product?.feature?.price_promotion?.replaceAll(".", ""))
          : 0;
        GTM.addProductToCart([
          {
            name: sci.product.name,
            id: sci.product.code,
            price: sci.product?.feature?.price
              ? parseInt(sci.product?.feature?.price?.replaceAll(".", ""))
              : 0,
            category: sci.product?.category_name,
            quantity: sci.quantity,
            promotion: "",
            variant: sci.product?.feature?.spec,
            discount_price: sci.product?.feature?.price_save
              ? parseInt(sci.product?.feature?.price_save.replaceAll(".", ""))
              : 0,
            unit_price: unit_price,
            subtotal_amount: unit_price * sci.quantity,
          },
        ]);

        await updateShoppingCartItems(sci, "");
        dispatch(getShoppingCart());
      }
    } else {
      dispatch(addToCart(product));
    }
  };

export const updateShoppingCart =
  (sci: IShoppingCartItem) => async (dispatch: Dispatch) => {
    await updateShoppingCartItems(sci, "");
    dispatch(getShoppingCart());
  };

export const deleteShoppingCartItem =
  (sci: IShoppingCartItem) => async (dispatch: Dispatch) => {
    await updateShoppingCartItems(undefined, sci._id);
    let unit_price = sci.product?.feature?.price_promotion
      ? parseInt(sci.product?.feature?.price_promotion?.replaceAll(".", ""))
      : 0;
    GTM.removeProductToCart([
      {
        name: sci.product.name,
        id: sci.product.code,
        category: sci.product?.category_name,
        price: sci.product?.feature?.price
          ? parseInt(sci.product?.feature?.price?.replaceAll(".", ""))
          : 0,
        quantity: sci.quantity,
        variant: sci.product?.feature?.spec,
        promotion: "",
        discount_price: sci.product?.feature?.price_save
          ? parseInt(sci.product?.feature?.price_save.replaceAll(".", ""))
          : 0,
        unit_price: unit_price,
        subtotal_amount: unit_price * sci.quantity,
      },
    ]);

    dispatch(getShoppingCart());
  };

export const applyVoucherCode =
  (data?: IPromotionVoucherCodeModel) => async (dispatch: Dispatch) => {
    // await updateShoppingCartItems(undefined, sci._id);
    await updateVoucherCode(data);
    dispatch(getShoppingCart());
  };

export const applyReferralCode =
  (data?: IReferralCodeModel) => async (dispatch: Dispatch) => {
    updateReferralCode(data);
    dispatch(getShoppingCart());
  };

export const setPaymentMethod = (info: any) => (dispatch: Dispatch) => {
  updatePaymentMethod(info);
};

export const setCaptchaToken = (info: any) => (dispatch: Dispatch) => {
  updateCaptchaToken(info);
};

export const setInvoiceInfo =
  (info: IInvoiceInfoModel) => (dispatch: Dispatch) => {
    updateInvoiceInfo(info);
  };

export const setOTPInfo = (info: IOTPInfo) => (dispatch: Dispatch) => {
  updateOTPInfo(info);
};

export const actionClearShoppingCart = () => (dispatch: Dispatch) => {
  dispatch(getShoppingCart());
};

export const selectCart = (state: IRootState) => state.cart.carts;

export default cartSlice.reducer;
